import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nav-inner" }
const _hoisted_2 = { class: "nav-links" }
const _hoisted_3 = { class: "nav-links" }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderMenu',
  setup(__props) {

const isFinance = computed(() => {
  if (typeof window === 'undefined') return false
  return window.location.hostname === 'finance.artrofimov.xyz'
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("div", _hoisted_1, [
      (isFinance.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "nav-logo"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("Art Finance ", -1),
                _createElementVNode("span", null, "Structural Health Monitoring", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("ul", _hoisted_2, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/live" }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("Live", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/cases" }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("Cases", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/session/signin" }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("Sign in", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("li", null, [
                _createElementVNode("a", { href: "https://artrofimov.xyz" }, "Art main")
              ], -1))
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "nav-logo"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Art ", -1),
                _createElementVNode("span", null, "Structural Health Monitoring", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("ul", _hoisted_3, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/session/signin" }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("Sign in", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ], 64))
    ])
  ]))
}
}

})